<template>
  <div id="app">
    <app-header/>
    <router-view/>
    <app-footer/>
  </div>
</template>
<script>
import Header from './components/header'
import Footer from './components/footer'
export default {
  name: 'App',
  components: {
    'app-header': Header,
    'app-footer': Footer
  }
}
</script>

<style>
@import './assets/css/font.css';
@import './assets/css/reset.css';
#app {
  position: relative;
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translateY(1.2rem);
    transform: translateY(1.2rem);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue